import axios from "axios";

const service = axios.create({
  baseURL: process.env.REACT_APP_COMMUNITY,
});

service.interceptors.request.use(
  (config) => config,
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const { data } = response;
    return data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
